import Vue from 'vue';
import router from './router';
import store from './store';
import ApiService from '@/services/ApiService';
import AuthService from '@/services/AuthService';
import vuetify from './plugins/vuetify';
import VuetifyConfirm from 'vuetify-confirm';
import VuetifyDialogPlugin from 'vuetify-dialog';
import moment from 'moment';
import '@/assets/main.css';
import '@/assets/theme.scss';
import CountryFlag from 'vue-country-flag';
import Component from 'vue-class-component';
import App from "@/App.vue";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import './registerServiceWorker';
import i18n from './i18n'

Vue.config.productionTip = false;

const bus = new Vue();
export default bus;

// before you will make any import
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate' // for vue-router 2.2+
]);

if (location.origin.includes('localhost')) {
    ApiService.initApi('http://localhost:8900/api');
} else {
    ApiService.initApi(`${location.origin}/api`);
}

ApiService.getSettings(() => {

    // Get user
    AuthService.refreshMe((response) => {
        bus.$emit('loading', false);

        new Vue({
            router,
            store,
            vuetify,
            i18n,
            render: h => h(App)
        }).$mount('#app');

        Vue.component('vue-phone-number-input', VuePhoneNumberInput);
        Vue.use(VuetifyConfirm, {vuetify});
        Vue.use(VuetifyDialogPlugin, {vuetify});

        moment.locale('da');
        Vue.filter('datetime', (value?: string) => {
            if (value) {
                return moment(String(value)).format('lll');
            }
        });
    });

});

Vue.component('country-flag', CountryFlag);
